import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Cabserviceinkharadi() {



const cardData = {
  keyword: " Cab Service in Kharadi",

"headingDescription": "SRS Cab Service offers Cab Service in Kharadi, providing reliable, comfortable, and efficient transportation for daily commuting, corporate travel, and airport transfers. Our well-maintained vehicles, professional drivers, and timely service ensure a smooth and hassle-free journey across Kharadi and Pune city. Ideal for office travel, airport pickups and drops, and outstation trips, SRS Cab Service delivers flexible booking options, transparent pricing, and 24/7 customer support for a convenient and stress-free travel experience.",
"topPlaces": [
  {
    "title": "EON IT Park",
    "description": "EON IT Park is a major business hub in Kharadi. Travelers using Cab Service in Kharadi from SRS Cab Service often commute here for office work and corporate meetings."
  },
  {
    "title": "World Trade Center Pune",
    "description": "World Trade Center Pune is a prominent commercial complex in Kharadi. Visitors using SRS Cab Service often travel here for business activities and conferences."
  },
  {
    "title": "Phoenix Marketcity",
    "description": "Phoenix Marketcity is a popular shopping and entertainment destination near Kharadi. Travelers using SRS Cab Service often visit for shopping, dining, and leisure."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace is a historic landmark located near Kharadi. Visitors using SRS Cab Service often explore its gardens and museum exhibits."
  },
  {
    "title": "Koregaon Park",
    "description": "Koregaon Park is a vibrant area known for cafes and nightlife. Travelers using SRS Cab Service often visit this place for dining and entertainment."
  },
  {
    "title": "Bund Garden",
    "description": "Bund Garden is a scenic riverside spot near Kharadi. Visitors using SRS Cab Service often relax here and enjoy nature."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "Dagdusheth Halwai Ganpati Temple is a famous religious site in Pune. Travelers using SRS Cab Service often visit to seek blessings."
  },
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada is a historic fort and a major tourist attraction in Pune. Visitors using SRS Cab Service often explore this landmark to learn about the city’s history."
  },
  {
    "title": "Osho Ashram",
    "description": "Osho Ashram in Koregaon Park is a well-known meditation center. Travelers using SRS Cab Service often visit for peace and spiritual experience."
  },
  {
    "title": "Kharadi Riverside",
    "description": "Kharadi Riverside is a peaceful spot along the river ideal for walks and relaxation. Visitors using SRS Cab Service often spend leisure time here enjoying scenic views."
  }
],



services: [
{
name: "Taxi Service in Kharadi",
description: "Taxi service in Kharadi offers reliable transportation for local and outstation travel. Customers can book taxis for daily and business trips. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with taxi services in Kharadi."
},
{
name: "Innova Crysta on Rent Kharadi",
description: "Innova Crysta on rent Kharadi provides premium SUV travel for families and corporate trips. Customers can enjoy spacious seating and comfort. Professional drivers ensure safe journeys. Ideal for outstation travel. Transparent pricing ensures value for money. Travel comfortably with Innova Crysta."
},
{
name: "Tempo Traveller on Rent in Kharadi",
description: "Tempo traveller on rent in Kharadi offers group travel solutions for tours and events. Customers can book spacious vehicles for family trips. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with tempo traveller services."
},
{
name: "Mini Bus on Rent in Kharadi",
description: "Mini bus on rent in Kharadi provides large group travel solutions. Customers can book buses for corporate and family trips. Professional drivers ensure safe journeys. Spacious seating enhances experience. Flexible booking options are available. Travel easily with mini bus services."
},
{
name: "Mini Bus on Rent for Outstation",
description: "Mini bus on rent for outstation offers reliable travel for long-distance group trips. Customers can book buses for tours and events. Professional drivers ensure safe highway journeys. Spacious seating enhances experience. Flexible booking options are available. Travel easily with mini bus services."
},
{
name: "Corporate Taxi Service in Kharadi Pune",
description: "Corporate taxi service in Kharadi Pune provides reliable transportation for offices and IT companies. Businesses can book cabs for employee travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with corporate taxi services."
},
{
name: "Kharadi to Mumbai Cab",
description: "Kharadi to Mumbai cab offers convenient intercity travel for business and airport trips. Customers can book cabs for comfortable journeys. Professional drivers ensure safe highway travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Kharadi to Aurangabad Cab Service",
description: "Kharadi to Aurangabad cab service provides reliable long-distance travel for customers. Users can book cabs for business and leisure trips. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Kharadi to Aliya Nagar Cab Service",
description: "Kharadi to Aliya Nagar cab service offers convenient travel for local and nearby routes. Customers can book cabs for flexible journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Ertiga on Rent in Kharadi",
description: "Ertiga on rent in Kharadi provides comfortable 7 seater travel for families and groups. Customers can book vehicles for local and outstation trips. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with Ertiga services."
},
{
name: "Swift Dzire on Rent in Kharadi",
description: "Swift Dzire on rent in Kharadi offers economical travel for daily and outstation trips. Customers can book vehicles for budget-friendly journeys. Professional drivers ensure safe travel. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with sedan services."
},
{
name: "Corporate Cab Service in Kharadi",
description: "Corporate cab service in Kharadi offers professional travel solutions for businesses. Companies can book cabs for employee transport and meetings. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with corporate cab services."
},
{
name: "Monthly Taxi Service in Kharadi",
description: "Monthly taxi service in Kharadi provides long-term travel solutions for offices and individuals. Customers can book cabs on monthly plans. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with monthly taxi services."
},
{
name: "Book Reliable Cabs in Kharadi - Local & Outstation Taxi",
description: "Book reliable cabs in Kharadi offers dependable travel for local and outstation trips. Customers can book cabs for flexible journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with reliable cab services."
},
{
name: "Kharadi to Nashik Cabs Booking",
description: "Kharadi to Nashik cabs booking provides easy travel options for long-distance trips. Customers can book cabs for business and leisure journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Kharadi to Mumbai Airport Taxi Booking",
description: "Kharadi to Mumbai airport taxi booking offers reliable airport transfer services. Customers can book taxis for timely travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with airport taxi services."
},
{
name: "Cab Service in Wagholi",
description: "Cab service in Wagholi provides convenient transportation for local and outstation travel. Customers can book cabs for daily and business trips. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
}
],

tableData: [
["Taxi Service in Kharadi","Innova Crysta on Rent Kharadi"],
["Tempo Traveller on Rent in Kharadi","Mini Bus on Rent in Kharadi"],
["Mini Bus on Rent for Outstation","Corporate Taxi Service in Kharadi Pune"],
["Kharadi to Mumbai Cab","Kharadi to Aurangabad Cab Service"],
["Kharadi to Aliya Nagar Cab Service","Ertiga on Rent in Kharadi"],
["Swift Dzire on Rent in Kharadi","Corporate Cab Service in Kharadi"],
["Monthly Taxi Service in Kharadi","Book Reliable Cabs in Kharadi - Local & Outstation Taxi"],
["Kharadi to Nashik Cabs Booking","Kharadi to Mumbai Airport Taxi Booking"],
["Cab Service in Wagholi","Taxi Service in Kharadi"]
],



whychoose: [
  {
    WhyChooseheading: "IT Hub Expertise in Kharadi",
    WhyChoosedescription: "SRS Cab Service provides reliable cab service in Kharadi with drivers familiar with EON IT Park, World Trade Center, and major corporate offices."
  },
  {
    WhyChooseheading: "Affordable Cab Service in Kharadi",
    WhyChoosedescription: "We offer budget-friendly cab services in Kharadi with transparent pricing. Customers receive clear fare details with no hidden charges."
  },
  {
    WhyChooseheading: "24/7 Cab Availability",
    WhyChoosedescription: "SRS Cab Service operates 24/7 in Kharadi, making it convenient for office commutes, airport transfers, and late-night travel."
  },
  {
    WhyChooseheading: "Comfortable & AC Vehicles",
    WhyChoosedescription: "Our fleet includes clean, well-maintained, and air-conditioned vehicles to ensure a smooth and comfortable ride within Kharadi and across Pune."
  },
  {
    WhyChooseheading: "Multiple Cab Options",
    WhyChoosedescription: "Choose from hatchbacks, sedans, SUVs like Ertiga and Innova, premium Innova Crysta, and Tempo Travellers for local and outstation travel."
  },
  {
    WhyChooseheading: "Quick Airport Pickup & Drop",
    WhyChoosedescription: "We provide fast cab service from Kharadi to Pune Airport and vice versa, ensuring timely airport transfers."
  },
  {
    WhyChooseheading: "Safe & Professional Drivers",
    WhyChoosedescription: "Our experienced drivers ensure safe driving, professional behavior, and a hassle-free travel experience."
  },
  {
    WhyChooseheading: "Trusted Cab Service in Kharadi Pune",
    WhyChoosedescription: "SRS Cab Service is trusted for cab service in Kharadi due to punctual service, clean vehicles, and excellent customer satisfaction."
  }
]
}

const faqData = [
  { question: "Do you provide cab service in Kharadi?", answer: "Yes, SRS Cab Service offers reliable cab services in Kharadi for local and outstation travel." },
  { question: "Is cab service available in Kharadi 24 hours?", answer: "Yes, our cab service operates 24/7 for all travel needs." },
  { question: "Do you provide airport cab service from Kharadi?", answer: "Yes, we provide Pune Airport pickup and drop services from Kharadi." },
  { question: "Which areas do you cover near Kharadi?", answer: "We cover EON IT Park, WTC, Viman Nagar, Wagholi, and nearby areas." },
  { question: "Which vehicles are available?", answer: "We offer hatchbacks, sedans, SUVs, Innova Crysta, and Tempo Travellers." },
  { question: "Can I book cab online in Kharadi?", answer: "Yes, you can easily book cab service online or via phone." },
  { question: "Do you provide one-way cab service?", answer: "Yes, we provide one-way and round-trip cab services from Kharadi." },
  { question: "Are drivers professional?", answer: "Yes, all drivers are trained, experienced, and professional." },
  { question: "Are vehicles air-conditioned?", answer: "Yes, all vehicles are fully air-conditioned for comfortable travel." },
  { question: "Are vehicles cleaned regularly?", answer: "Yes, all vehicles are regularly cleaned and sanitized for safety." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rohit Kulkarni",
    feedback:
      "Booked cab from Kharadi to airport. Very quick service and professional driver.",
    rating: 5
  },
  {
    id: 2,
    name: "Ms. Sneha Patil",
    feedback:
      "Best cab service in Kharadi. Clean car, on-time pickup, and smooth ride.",
    rating: 5
  }
];




























const Images = [
{ place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "Pune-Cab-Service" },
{ place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "Pune-Taxi-Hire" },
{ place: "/images/keyword/3.jpg", text: "Pune Online Cabs Booking", link: "Pune-Online-Cabs-Booking" },
{ place: "/images/keyword/4.jpg", text: "Best Cabs Service in Pune", link: "Best-Cabs-Service-in-Pune" },
{ place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cab", link: "Pune-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab", link: "Pune-to-Lonavala-Cab" },
{ place: "/images/keyword/9.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Pune to Shirdi Cab", link: "Pune-to-Shirdi-Cab" },
{ place: "/images/keyword/11.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
{ place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cab", link: "Pune-to-Konkan-Darshan-Cab" },
{ place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
{ place: "/images/keyword/15.jpg", text: "Pune Outstation Cabs", link: "Pune-Outstation-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab", link: "Pune-to-Panchgani-Cab" },
{ place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
{ place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab", link: "Ashtavinayak-Darshan-Cab" },
{ place: "/images/keyword/19.jpg", text: "Pune to Nagpur Cab", link: "Pune-to-Nagpur-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Goa Cab", link: "Pune-to-Goa-Cab" },
{ place: "/images/keyword/21.jpg", text: "Pune to Ajanta Ellora Cab", link: "Pune-to-Ajanta-Ellora-Cab" },
{ place: "/images/keyword/22.jpg", text: "Pune to Satara Cabs", link: "Pune-to-Satara-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Pune Airport Cabs", link: "Pune-Airport-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Pune to Ayodhya Tour Package", link: "Pune-to-Ayodhya-Tour-Package" },
{ place: "/images/keyword/25.jpg", text: "Corporate Cab Service in Pune", link: "Corporate-Cab-Service-in-Pune" },
];













const jsonData = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "name": "SRS Cab - Kharadi Cab Service",
  "description": "Reliable cab service in Kharadi, Pune with SRS Cab. Book taxis for local travel, airport transfers, outstation trips, and corporate rides. 24/7 service with Innova, Ertiga, Swift Dzire, tempo traveller, and mini bus options.",
  "image": "https://www.srscabservice.com/logo.png",
  "telephone": "+91 9011955415",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "Kharadi",
    "addressLocality": "Pune",
    "addressRegion": "Maharashtra",
    "postalCode": "411014",
    "addressCountry": "IN"
  },
  "geo": {
    "@type": "GeoCoordinates",
    "latitude": "18.5543",
    "longitude": "73.9143"
  },
  "url": "https://www.srscabservice.com/kharadi-cab-service",
  "priceRange": "₹₹",
  "openingHours": "Mo-Su 00:00-23:59",
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "bestRating": "5",
    "worstRating": "1",
    "ratingCount": "1380"
  },
  "areaServed": {
    "@type": "City",
    "name": "Kharadi, Pune"
  }
};





  return (
    <div>
      <Helmet>
  <title>Cab Service in Kharadi | Call +91 9011955415 | SRS Cab</title>
  <meta 
    name="description" 
    content="Book reliable cab service in Kharadi, Pune with SRS Cab. Local rides, airport transfers, outstation trips, and corporate taxi services available 24/7. Innova, Ertiga, Swift Dzire, tempo traveller, and mini bus options." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>




 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/51.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#030706', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Srs Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2 d-flex">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
               <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Srs Cab Service</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Srs Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                        //   title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919011955415" className="pc-call">+91 9011955415</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919011955415"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919011955415" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@srscabservice.com" className="pc-email">
        booking@srscabservice.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Srs Cab Service</strong><br />
        Office no. 3 Mankar corner, kaspate chowk wakad Pune 411027
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Cabserviceinkharadi;